import {Component} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {TranslateService} from "app/translate/translate.service";
import {FilterFormService} from "app/views/filter_form/filter_form.service";
import {PaidDetailsComponent} from "app/views/modal/paid_details/paid_details.component";

import * as moment from 'moment-timezone';
import merge from 'lodash-es/merge';

import {ChartParams} from "app/views/chart/chart.component";
import {HelperService} from "app/lib/helper.service";
import {ModalService} from "app/views/modal/base_modal.component";
import {BaseComponent} from "app/views/base.component";
import {EventsService} from "app/lib/EventsService";
import {RouteProvider} from "../../provider/route.provider";
import { BillingService2 } from "../billing.service";

class PeriodData {
	count: number = 0;
	siteIds: string[] = [];
}

class Periods {
	'month': PeriodData = new PeriodData();
	'3months': PeriodData = new PeriodData();
	'6months': PeriodData = new PeriodData();
	'12months': PeriodData = new PeriodData();
	'24months': PeriodData = new PeriodData();
	'gt24months': PeriodData = new PeriodData();
	'total': PeriodData = new PeriodData();
}

class MonthData {
	date: number;
	disabled: Periods = new Periods();
	manualPaid: Periods = new Periods();
	off: Periods = new Periods();
	paid: Periods = new Periods();
	paidAlive: Periods = new Periods();
	recurrent: Periods = new Periods();
	recurrentOff: Periods = new Periods();
	strange: Periods = new Periods();
	waitForPaid: Periods = new Periods();
}

class ExpiredPaidData {
	month: string;
	opened: boolean = false;
	data: MonthData = new MonthData();
}


type DeadSiteRsult = {
	values;
	categories;
};

interface IPaidByMonthData {
	paidCount: number;
	siteCount: number;
	dateXList: object[];
	stats: object[];
}


@Component({
	selector: 'expired-paid',
	templateUrl: './expired_paid.component.html'
})
export class ExpiredPaidComponent extends BaseComponent {
	settings = {
		'paid': {
			i18n: 'adminstat.billing.expired_paid.paid',
			isHidden: false
		},
		'off': {
			i18n: 'adminstat.billing.expired_paid.Falls',
			isHidden: true
		},
		'paidAlive': {
			i18n: 'adminstat.billing.expired_paid.living',
			isHidden: false
		},
		'disabled': {
			i18n: 'adminstat.billing.expired_paid.unsubscribed',
			isHidden: true
		},
		'waitForPaid': {
			i18n: 'adminstat.billing.expired_paid.expected recurents',
			isHidden: true
		},
		'recurrent': {
			i18n: 'adminstat.billing.expired_paid.recurents',
			isHidden: true
		},
		'recurrentOff': {
			i18n: 'adminstat.billing.expired_paid.off recurents',
			isHidden: true
		},
		'manualPaid': {
			i18n: 'adminstat.billing.expired_paid.manual payments',
			isHidden: true
		},
		'strange': {
			i18n: 'adminstat.billing.expired_paid.strangers',
			isHidden: true
		}
	};
	
	deathSitesChartData = new ChartParams();


	paidAliveData: any = {};
	paidAliveChartData = new ChartParams({
		names: {
			'Avg': this.translate.__A('common.Avg'),
			'Avg2': this.translate.__A('common.Avg2')
		}
	});
	paidAliveChartValue: string = 'relative';
	
	
	expiredChartData = new ChartParams();
	expiredData1: any[] = ['Выжило'];
	expiredData2: any[] = ['Отвалилось'];
	expiredChartPeriod: string = 'total';
	expiredChartValue: string = 'absolute';
	cumLtvChartData = new ChartParams();

	monthsList: string[] = [];
	months: ExpiredPaidData[] = [];

	fallenLoader: boolean = false;
	paidsByMonthsLoader: boolean = false;
	paidsByNumLoader: boolean = false;
	expiredChartPercentLoader: number = 100;

	paidByMonthData: IPaidByMonthData;
	paidByNumData;

	public moment = moment;

	addFilterParams = {
		userType: 'user',
		isExpiredPaid: true,
		dateFilters: ['datePaid', 'dateCreated', 'dateSiteCreated']
	};
	
	constructor(
		public translate: TranslateService,
		public eventsService: EventsService,
		public activatedRoute: ActivatedRoute,
		public filter: FilterFormService,
		public modalService: ModalService,
		public routeProvider: RouteProvider,
		public helper: HelperService,
		public service2: BillingService2,
	) {
		super(eventsService, service2, activatedRoute, filter, translate);
	}
	
	
	async getData() {
		await this.getPaidAlive();
		await this.getDeathSites();
		await this.getMonths();
		await this.getPaidsByMonth();
		await this.getPaidsByNum();
		await this.getCumLtvData();
	}
	
	
	async getPaidAlive() {
		this.paidAliveChartData.showLoader();
		
		
		this.paidAliveChartData.setOptions({
			showLabels: [
				'Avg2'
			],
			title: this.translate.__A('billing.expired_paid.By paidalive'),
			grid: {
				y: {
					lines: [{value: 0}]
				}
			},
			axis: {
				x: {
					type: 'category',
					categories: this.paidAliveData.categories,
					tick: {
						culling: {
							max: 20
						}
					},
					label: {
						text: this.translate.__A('billing.expired_paid.firstPaidMonth'),
						position: 'outer-middle'
					}
				},
				y: {
					label: {
						text: this.translate.__A('billing.expired_paid.aliveSitesPercent'),
						position: 'outer-middle'
					}
				}
			},

			lazyRender: true,
		});

		this.paidAliveData = await this.service2.expiredPaid.get(
			this.filter.filterParams,
			'paidalive',
		).toPromise();

		this.paidAliveChartData.data = this.paidAliveData.relativeValues;
		
		this.paidAliveChartData.hideLoader();
	}
	
	
	async getDeathSites() {
		this.deathSitesChartData.showLoader();
		
		const data = await this.service2.expiredPaid.get<DeadSiteRsult>(
			this.filter.filterParams,
			'death_sites',
		).toPromise();
		
		this.deathSitesChartData.data = data.values;
		this.deathSitesChartData.setOptions({
			title: this.translate.__A('billing.expired_paid.dead sites chart'),
			grid: {
				y: {
					lines: [{value: 0}]
				}
			},
			axis: {
				x: {
					type: 'category',
					categories: data.categories,
					tick: {
						culling: {
							max: 20
						}
					}
				}
			}
		});
		
		this.deathSitesChartData.hideLoader();
	}
	
	
	async getMonths() {
		const me = this;

		me.months = [];
		
		if (me.filter.filterParams.isShowExpiredPaidAddFields) {
			Object.keys(me.settings).forEach(function(field) {
				me.settings[field].isHidden = false;
			});
		} else {
			Object.keys(me.settings).forEach(function(field) {
				if (field === 'paid' || field === 'paidAlive') {
					me.settings[field].isHidden = false;
				} else {
					me.settings[field].isHidden = true;	
				}
			});
		}

		me.fallenLoader = true;
		
		const { stats } = await me.service2.expiredPaid.stats(
			me.filter.filterParams,
			'fall/dates',
		).toPromise();
		me.monthsList = stats;

		me.fallenLoader = false;

		me.expiredChartPercentLoader = 0;

		let i = 0;
		const tick = 100 / me.monthsList.length;
		for (let month of me.monthsList) {
			const data = await me.service2.expiredPaid.get(
				me.filter.getCopyFilterParams({ month }),
				'fall/month',
			).toPromise();
			
			me.months.push(
				merge(
					{},
					new ExpiredPaidData(),
					{
						month: moment(month).tz('Europe/Moscow').format('01.MM.YYYY'),
						data,
					}
				)
			);

			me.expiredChartPercentLoader = Math.ceil(i * tick);

			i++;
		}

		me.expiredChartPercentLoader = 100;

		me.setExpiredChartData();
	}
	
	async getCumLtvData() {
		const { charts } = await this.service2.expiredPaid.chart(
			this.filter.filterParams,
			'cum_ltv',
		).toPromise();
		
		this.cumLtvChartData.data = charts;
	}
	
	setExpiredChartData() {
		const me = this;

		me.expiredChartData.showLoader();

		me.monthsList = [];
		me.expiredData1 = ['paidAlive'];
		me.expiredData2 = ['off'];
		
		for (let month of me.months) {
			me.monthsList.push(month.month);
			
			let paid = typeof month.data.paidAlive[me.expiredChartPeriod] != 'undefined' ? month.data.paidAlive[me.expiredChartPeriod].count : 0;
			let off = typeof month.data.off[me.expiredChartPeriod] != 'undefined' ? month.data.off[me.expiredChartPeriod].count : 0;
			
			if (me.expiredChartValue == 'relative') {
				let total = paid + off;
				paid = (100 * paid / total).toFixed(0);
				off = (100 * off / total).toFixed(0);
			}
			
			me.expiredData1.push(paid);
			me.expiredData2.push(off);
		}

		me.expiredChartData.setOptions({
			type: 'bar',
			grid: {
				y: {
					lines: [{value: 0}]
				}
			},
			axis: {
				x: {
					type: 'category',
					categories: me.monthsList,
					tick: {
						culling: {
							max: 3
						}
					}
				}
			},
			groups: ['paidAlive', 'off'],
			events: {
				onclick: async function({id, index}) {
					await me.showExpiredChartDetail(
						me.monthsList[index],
						me.months[index].data[id][me.expiredChartPeriod].siteIds
					);
				}
			},
			names: {
				paidAlive: 'Выжило',
				off: 'Отвалилось',
			},
		});
		me.expiredChartData.data = [me.expiredData1, me.expiredData2];

		me.expiredChartData.hideLoader();
	}


	changeExpiredChartPeriod(period: string) {
		if (this.expiredChartPeriod == period) {
			return true;
		}
		
		this.expiredChartPeriod = period;
		this.setExpiredChartData();
	}
	
	
	changeExpiredChartValue(value: string) {
		if (this.expiredChartValue == value) {
			return true;
		}
		
		this.expiredChartValue = value;
		this.setExpiredChartData();
	}


	changePaidAliveChartValue(value: string) {
		if (this.paidAliveChartValue == value) {
			return true;
		}

		this.paidAliveChartValue = value;

		if (value == 'absolute') {
			this.paidAliveChartData.data = this.paidAliveData.absoluteValues;	
		} else {
			this.paidAliveChartData.data = this.paidAliveData.relativeValues;
		}
		
	}
	
	
	showTableRow(month: ExpiredPaidData, period: string) {
		if (period !== 'total') {
			return true;
		}
		
		month.opened = !month.opened;
	}
	
	
	async showRowDetails(siteIds: string[], month: string) {
		if (siteIds.length === 0) {
			return true;
		}
		
		const modalRef = this.modalService.open(
			PaidDetailsComponent,
			{
				title: month,
				params: this.filter.filterParams,
			},
			{size: 'hg'}
		);
		
		const { stats } = await this.service2.siteBilling.detail(
			this.filter.getCopyFilterParams({ siteIds, })
		).toPromise();
		modalRef.componentInstance.details = stats;
		
		console.log('details', modalRef.componentInstance.details);
	}
	
	
	async getPaidsByMonth() {
		this.paidsByMonthsLoader = true;
		
		this.paidByMonthData = await this.service2.expiredPaid.get<IPaidByMonthData>(
			this.filter.filterParams,
			'month',
		).toPromise();
		
		this.paidsByMonthsLoader = false;
	}
	
	
	async getPaidsByNum() {
		this.paidsByNumLoader = true;
		
		this.paidByNumData = await this.service2.expiredPaid.get(
			this.filter.filterParams,
			'paid_num',
		).toPromise();
		
		this.paidsByNumLoader = false;
	}
	
	
	createRange(number): number[] {
		const items: number[] = [];
		for (let i = 1; i <= number; i++) {
			items.push(i);
		}
		return items;
	}

	async reportDateTypeChange() {
		const me = this;

		await me.routeProvider.navigate(me.filter.getApplyFilters(me.filter.filterParams));
	}
	
	async showExpiredChartDetail(month: string, siteIds: string[]) {
		if (siteIds.length === 0) {
			return true;
		}

		const modalRef = this.modalService.open(
			PaidDetailsComponent,
			{
				title: month,
				params: this.filter.filterParams,
			},
			{size: 'hg'}
		);

		const { stats } = await this.service2.siteBilling.detail(
			this.filter.getCopyFilterParams({ siteIds, })
		).toPromise();
		modalRef.componentInstance.details = stats;
	}
}
